'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
      checked = _ref.checked,
      readOnly = _ref.readOnly,
      className = _ref.className,
      props = (0, _objectWithoutProperties3.default)(_ref, ['label', 'checked', 'readOnly', 'className']);

  return _react2.default.createElement('label', (0, _extends3.default)({
    className: (0, _classnames2.default)(className, 'frm-Form_Checkbox', {
      'util-Pe-none': readOnly
    })
  }, props), _react2.default.createElement('input', { type: 'checkbox', checked: checked, readOnly: readOnly }), _react2.default.createElement('span', { className: 'frm-Form_CheckboxIcon' }, _react2.default.createElement('span', { className: 'frm-Form_CheckboxCheck am-icon-check' })), label && _react2.default.createElement('p', { className: 'frm-Form_Label' }, label));
};

Checkbox.defaultProps = {
  label: undefined,
  checked: false,
  readOnly: false,
  className: undefined
};

Checkbox.propTypes = {
  label: _propTypes2.default.string,
  checked: _propTypes2.default.bool.isRequired,
  readOnly: _propTypes2.default.bool,
  className: _propTypes2.default.string
};

exports.Checkbox = Checkbox;